export interface ExternalFindings extends Record<string, number | undefined> {
  readonly afibBurden: number | undefined;
  readonly afibTotalDuration: number | undefined;
  readonly averageHeartRate: number | undefined;
  readonly minimumHeartRate: number | undefined;
  readonly afibMinimumHeartRate: number | undefined;
  readonly sinusMinimumHeartRate: number | undefined;
  readonly afibMaximumHeartRate: number | undefined;
  readonly sinusMaximumHeartRate: number | undefined;
  readonly maximumHeartRate: number | undefined;
  readonly afibAverageHeartRate: number | undefined;
  readonly pausesOverThreshold: number | undefined;
  readonly pausesOverThresholdLongestDuration: number | undefined;
  readonly ventricularBeats: number | undefined;
  readonly ventricularBeatsBurden: number | undefined;

  readonly ventricularCoupletsCount: number | undefined;

  readonly ventricularTachycardias: number | undefined;
  readonly ventricularTachycardiasLongestDuration: number | undefined;
  readonly ventricularTachycardiasLongestDurationMaxHeartRate: number | undefined;
  readonly ventricularTachycardiasMaxHeartRate: number | undefined;
  readonly ventricularTachycardiasLongestDurationBeats: number | undefined;
  readonly ventricularTachycardias_deprecated: number | undefined;
  readonly ventricularTachycardiasLongestDuration_deprecated: number | undefined;
  readonly ventricularTachycardiasLongestBeats_deprecated: number | undefined;
  readonly ventricularTachycardiasLongestBeatsMaxHeartRate_deprecated: number | undefined;
  readonly ventricularTachycardiasMaxHeartRate_deprecated: number | undefined;
  readonly ventricularTachycardiasMaxHeartRateBeats_deprecated: number | undefined;
  readonly ventricularTachycardiasMaxHeartRateDuration_deprecated: number | undefined;
  readonly ventricularTachycardiasLongestDurationMaxHeartRate_deprecated: number | undefined;
  readonly ventricularTachycardiasLongestDurationBeats_deprecated: number | undefined;

  readonly slowVentricularRhythmCount: number | undefined;
  readonly slowVentricularRhythmLongestDuration: number | undefined;
  readonly slowVentricularRhythmLongestDurationBeats: number | undefined;
  readonly slowVentricularRhythmLongestDurationMaximumHeartRate: number | undefined;

  readonly atrialBeats: number | undefined;
  readonly atrialBeatsBurden: number | undefined;
  readonly atrialTachycardias: number | undefined;
  readonly atrialTachycardiasLongestBeats: number | undefined;
  readonly atrialTachycardiasLongestBeatsMaximumHeartRate: number | undefined;
  readonly atrialTachycardiasLongestDuration: number | undefined;
  readonly atrialTachycardiasMaximumHeartRate: number | undefined;
  readonly atrialTachycardiasMaximumHeartRateDuration: number | undefined;
  readonly atrialTachycardiasMaximumHeartRateBeats: number | undefined;
  readonly atrialTachycardiasLongestDurationMaxHeartRate: number | undefined;
  readonly atrialTachycardiasLongestDurationBeats: number | undefined;
  readonly vRuns: number | undefined;
  readonly sRuns: number | undefined;
}

export const emptyExternalFindings: ExternalFindings = {
  afibBurden: undefined,
  afibTotalDuration: undefined,
  averageHeartRate: undefined,
  minimumHeartRate: undefined,
  afibMinimumHeartRate: undefined,
  sinusMinimumHeartRate: undefined,
  afibMaximumHeartRate: undefined,
  sinusMaximumHeartRate: undefined,
  maximumHeartRate: undefined,
  afibAverageHeartRate: undefined,
  pausesOverThreshold: undefined,
  pausesOverThresholdLongestDuration: undefined,
  ventricularBeats: undefined,
  ventricularBeatsBurden: undefined,

  ventricularCoupletsCount: undefined,

  ventricularTachycardias: undefined,
  ventricularTachycardiasLongestDuration: undefined,
  ventricularTachycardiasLongestDurationMaxHeartRate: undefined,
  ventricularTachycardiasMaxHeartRate: undefined,
  ventricularTachycardiasLongestDurationBeats: undefined,

  ventricularTachycardias_deprecated: undefined,
  ventricularTachycardiasLongestDuration_deprecated: undefined,
  ventricularTachycardiasLongestBeats_deprecated: undefined,
  ventricularTachycardiasLongestBeatsMaxHeartRate_deprecated: undefined,
  ventricularTachycardiasMaxHeartRate_deprecated: undefined,
  ventricularTachycardiasMaxHeartRateBeats_deprecated: undefined,
  ventricularTachycardiasMaxHeartRateDuration_deprecated: undefined,
  ventricularTachycardiasLongestDurationMaxHeartRate_deprecated: undefined,
  ventricularTachycardiasLongestDurationBeats_deprecated: undefined,

  slowVentricularRhythmCount: undefined,
  slowVentricularRhythmLongestDuration: undefined,
  slowVentricularRhythmLongestDurationBeats: undefined,
  slowVentricularRhythmLongestDurationMaximumHeartRate: undefined,

  atrialBeats: undefined,
  atrialBeatsBurden: undefined,
  atrialTachycardias: undefined,
  atrialTachycardiasLongestBeats: undefined,
  atrialTachycardiasLongestBeatsMaximumHeartRate: undefined,
  atrialTachycardiasLongestDuration: undefined,
  atrialTachycardiasMaximumHeartRate: undefined,
  atrialTachycardiasMaximumHeartRateDuration: undefined,
  atrialTachycardiasMaximumHeartRateBeats: undefined,
  atrialTachycardiasLongestDurationMaxHeartRate: undefined,
  atrialTachycardiasLongestDurationBeats: undefined,
  vRuns: undefined,
  sRuns: undefined
};
